<div class="wrapper wrapper-content mtv-user-role-page row hide-list-nav-tabs">
    <div class="ibox mainPartPage"
         [class.showDetailedView]="isShowView"
         [ngStyle]="{width: isShowView ? 'calc(100% - 705px)' : '100%'}">
        <div class="ibox-content">
            <div class="row">
                <div class="col-sm-7">
                    <filter [tabHeading]="'User Role'"></filter>
                </div>
                <div class="col-sm-5">
                    <button type="button" class="btn btn-w-m btn-primary pull-right" (click)="createNew()">
                        <i class="fa fa-plus-circle"></i> New User Role
                    </button>
                </div>
            </div>
            <tabs-wrapper>
                <tab-item [tabId]="'user-role'">

            <div class="table-responsive"
                 [ngClass]="{'sk-loading': userRoleService.spinnerShow}"
                 [class.overflow-hidden]="userRoleService.emptyRowService.emptyRow.length > 0"
                 *ngIf="userRoleService.total !== null">
                <table class="table table-striped table-hover footable" *ngIf="userRoleService.data.length">
                    <thead>
                    <tr [ngClass]="{'noSort': userRoleService.data.length < 2}">
                        <th></th>
                        <th (click)="adminService.urlService.orderBy('id', $event)">
                            ID <span class="footable-sort-indicator"></span>
                        </th>
                        <th (click)="adminService.urlService.orderBy('name', $event)">
                            User Role Name <span class="footable-sort-indicator"></span>
                        </th>
                        <th class="footable-sorted-desc" (click)="adminService.urlService.orderBy('createdAt', $event)">
                            Created On<span class="footable-sort-indicator"></span>
                        </th>
                        <th># of Users</th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr *ngFor="let item of userRoleService.data" [ngClass]="{'footable-odd': (index % 2 === 0)}"
                        (click)="toggleDetails(item)">
                        <td>
                            <label class="img-checkbox">
                                <input type="checkbox" [ngModel]="item.checked">
                                <label><svg-checked></svg-checked></label>
                            </label>
                        </td>
                        <td>{{item.id}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.createdAt ? transformDate(item.createdAt) : '-'}}</td>
                        <td>{{item.numberOfUsers}}</td>
                    </tr>
                    <tr *ngFor="let item of userRoleService.emptyRowService.emptyRow" style="cursor: default;">
                        <td></td><td>&nbsp;</td><td></td><td></td><td></td>
                    </tr>
                    </tbody>
                </table>

                <div *ngIf="userRoleService.total === 0" class="text-center">
                    <h2>Result Not Found</h2>
                    <a class="text-center">
                        <broad-match-toggle></broad-match-toggle>
                    </a>
                </div>
            </div>
                </tab-item>


            <pagination
                *ngIf="userRoleService.total && userRoleService.urlService.queryParams['page'] && !userRoleService.spinnerShow"
                [total]="userRoleService.total">
            </pagination>

            <spinner [spinnerShow]="userRoleService.spinnerShow"></spinner>

            </tabs-wrapper>

        </div>
    </div>

    <div class="animated animated-directory slideInRight detailed-view dv-sidebar" *ngIf="isShowView">
        <role-item-view *ngIf="!userRoleService.showAmenityPermissionsTable"
                        [itemData]="viewedItem"
                        [close]="closeDetails.bind(this)"
                        [update]="updateItem.bind(this)">
        </role-item-view>
        <amenity-permissions-view *ngIf="userRoleService.showAmenityPermissionsTable"
                                  [role]="viewedItem"
                                  [close]="closeDetails.bind(this)">
        </amenity-permissions-view>
    </div>
</div>
<create-modal *ngIf="isCreateNew" (onClose)="closeCreateNew()" [create]="createItem.bind(this)"></create-modal>



// WEBPACK FOOTER //
// /app/src/app/views/admin/user-role/user-role.component.html